import React from 'react';
import moment from 'moment';
import './App.css';
import { useTranslation } from 'react-i18next';
import { Packet } from './api/Models';
import { RestClient } from './api/RestClient';
import PacketSearch from './PacketSearch';
import PacketDetail from './PacketDetail';
import PacketBuy from './PacketBuy';
import PacketBuyed from './PacketBuyed';
import PacketLinkBuy from './PacketLinkBuy';

function App() {
  const [pageState, setPageState] = React.useState<string>('search');
  const [packets, setPackets] = React.useState<Packet[] | undefined>();
  const [srchDate, setSrchDate] = React.useState<Date | null | undefined>(null);
  const [packet, setPacket] = React.useState<Packet | undefined>();
  const [pageError, setPageError] = React.useState<string | undefined>();
  const [payLink, setPayLink] = React.useState<string | undefined>();
  const { t } = useTranslation();

  const search = async (srchDt: Date | null | undefined): Promise<void> => {
    setPageError('');
    setPacket(undefined);
    setSrchDate(srchDt);
    console.log(srchDt);
    if (srchDt) {
      // 
      try {
        const sDate = moment(srchDt).format('YYYY-MM-DD');
        let p = await RestClient.getInstance().findPackets(sDate);
        setPackets(p);
        if (!p || p.length === 0) {
          setPageError(t('noPacketsInSrchDate'));
        } else {
          setPageError(t('packetsFound'));
        }
      } catch(err) {
        console.log('Error search packets.', err);
        setPageError(t('packetsSearchFailed'));
      }
    }
  };

  const packetDetail = async (index: number): Promise<void> => {
    if (index >= 0 && packets && packets.length > index ) {
      let cp = packets[index];
      if (cp) {
        let pDet = await RestClient.getInstance().getPacket(cp.id);
        console.log(pDet);
        if (pDet) {
          if (pDet.images) {
            pDet.images.forEach(cp => cp.src = (process.env.REACT_APP_API_BASE_URL || '')+'/sale/imgth/'+pDet.id+'/'+cp.name);
          }
        
          setPacket(pDet);
          setPageState('detail');
        }
      }
    }
  };

  const back = async () => {
    switch(pageState) {
      case 'detail':
        setPacket(undefined);
        setPageState('search');
        break;
      case 'buy':
        setPageState('detail');
        break;
      case 'buyed':
        setPageState('search');
        break;
    }
  }

  const packetBuy = async () => {
    setPageState('buy');
  }

  const clickLinkBtn = async (paylink: string) => {
    // Simula l'aggiunt di un link e il click
    const link = document.getElementById('peekButton');
    if (link) {
      link.setAttribute('href', paylink);
      link.click();
    }
  }

  const packetBuyed = async (paylink?: string) => {
    setPacket(undefined);
    if (paylink) {
      // vado alla pagina principale
      setPageState('search');
      // Apro il link
      //setPayLink(paylink);
      clickLinkBtn(paylink);
    } else {
      setPageState('buyed');
    }
  }

  return (
    <>
    {pageState === 'search' &&
      <PacketSearch  packets={packets} srchDate={srchDate} pageError={pageError} search={search} packetDetail={packetDetail} />
    }
    {(pageState === 'detail' && packet ) &&
      <PacketDetail  packet={packet} packetBuy={packetBuy} back={back} />
    }
    {(pageState === 'buy' && packet ) &&
      <PacketBuy packet={packet} packetBuyed={packetBuyed} back={back} />
    }
    {pageState === 'buyed' &&
      <PacketBuyed back={back} />
    }
    {payLink &&
      <PacketLinkBuy paylink={payLink} back={() => setPayLink(undefined)} />
    }
    </>
  );
}

export default App;
